import { createTheme } from '@mui/material/styles';

export const mdTheme = createTheme({
  components: {
    MuiButton: {
      variants: [
        {
          props: { id: 'ledger-search-btn' },
          style: {
            borderRadius: '24px',
            border: '2px solid #39A2DB',
            padding: '6px 24px',
            fontFamily: 'Work Sans',
            textTransform: 'none',
            color: '#39A2DB',
            fontWeight: '800',

            '&:hover': {
              border: '2px solid #39A2DB',
            },
            '&:active': {
              boxShadow: 'none',
            },
          },
        },
      ],
    },
    MuiTypography: {
      variants: [
        {
          props: { id: 'ledger-header-text-large' },
          style: {
            fontFamily: 'Work Sans',
            color: '#14142B',
            fontSize: '20px',
            fontWeight: '800',
            marginRight: 10,
          },
        },
        {
          props: { id: 'ledger-header-text-medium' },
          style: {
            fontFamily: 'Work Sans',
            color: '#14142B',
            fontSize: '16px',
            fontWeight: '400',
          },
        },
        {
          props: { id: 'ledger-error-status-code' },
          style: {
            fontFamily: 'Work Sans',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '40px',
            lineHeight: '23px',
            color: '#2E82AF',
            textAlign: 'center',
            marginTop: '10px',
          },
        },
        {
          props: { id: 'ledger-error-heading' },
          style: {
            fontFamily: 'Work Sans',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '20px',
            lineHeight: '23px',
            color: '#9E9E9E',
            textAlign: 'center',
            marginTop: '10px',
          },
        },
        {
          props: { id: 'ledger-error-message' },
          style: {
            fontFamily: 'Work Sans',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '23px',
            color: '#9E9E9E',
            textAlign: 'center',
            marginTop: '10px',
          },
        },
      ],
    },
    MuiTableCell: {
      variants: [
        {
          props: { id: 'subTitle' },
          style: {
            fontFamily: 'Work Sans',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '22px',
            color: '#14142B',
          },
        },
        {
          props: { id: 'content' },
          style: {
            fontFamily: 'Work Sans',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '18px',
            color: '#14142B',
          },
        },
      ],
    },
    MuiStack: {
      variants: [
        {
          props: { id: 'ledger-container' },
          style: { background: '#ffffff', borderRadius: '24px', overflow: 'hidden', height: 'calc( 100vh - 144px )', pb: '64px' },
        },
        {
          props: { id: 'ledger-spinner-container' },
          style: {
            height: '1100px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        },
      ],
    },
    MuiAutocomplete: {
      variants: [
        {
          props: { id: 'properties-address-dropdown' },
          style: {
            minWidth: '220px',
            '&.MuiInputBase-root': {
              borderRadius: 24,
            },
            '& .MuiInputBase-root': {
              borderRadius: 24,
            },
          },
        },
      ],
    },
  },
});
